var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, styled } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import clsx from 'clsx';
/**
 * A Material-UI Avatar with fallback to the Person icon if no url was provided for an image.
 */
export var EventAvatar = function (props) {
    var className = props.className, src = props.src, fullName = props.fullName, _a = props.size, size = _a === void 0 ? 'medium' : _a, rest = __rest(props, ["className", "src", "fullName", "size"]);
    return (_jsx(Root, __assign({ src: src, className: clsx(className, EventAvatarClasses[size]) }, rest, { children: !!src ? null : fullName ? getInitials(fullName) : _jsx(PersonIcon, {}) })));
};
var PREFIX = 'RaEventAvatar';
export var EventAvatarClasses = {
    small: "".concat(PREFIX, "-small"),
    medium: "".concat(PREFIX, "-medium"),
};
var Root = styled(Avatar, {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})((_a = {},
    _a["&.".concat(EventAvatarClasses.small)] = {
        width: 20,
        height: 20,
        fontSize: '0.7rem',
    },
    _a["&.".concat(EventAvatarClasses.medium)] = {
        width: 40,
        height: 40,
        fontSize: '1rem',
    },
    _a));
export var getInitials = function (name) {
    var hasMultipleWords = name.trim().indexOf(' ') !== -1;
    return (
    // Get the first letter of the first word
    name.substring(0, 1).toLocaleUpperCase() +
        // If there are multiple words, get the first letter of the last word
        (hasMultipleWords
            ? name.charAt(name.lastIndexOf(' ') + 1).toLocaleUpperCase()
            : ''));
};
